import { Controller } from "@hotwired/stimulus"

// Controls the "Record New Offer" panel on the settlement tracker.
// The form is shown by default; a toggle button lets the user collapse
// it and re-open it. The button is hidden in the markup until this
// controller connects (progressive enhancement — no JS, no toggle).
export default class extends Controller {
  static targets = ["form", "toggleBtn"]

  connect() {
    // Reveal the toggle control only when JS is available.
    if (this.hasToggleBtnTarget) {
      this.toggleBtnTarget.classList.remove("hidden")
    }
    this.syncLabel()
  }

  toggle() {
    if (!this.hasFormTarget) return

    this.formTarget.classList.toggle("hidden")
    this.syncLabel()
  }

  // Keep the button label/state in sync with the form's visibility.
  syncLabel() {
    if (!this.hasToggleBtnTarget) return

    const hidden = this.hasFormTarget && this.formTarget.classList.contains("hidden")
    this.toggleBtnTarget.textContent = hidden ? "Show Form" : "Hide Form"
    this.toggleBtnTarget.setAttribute("aria-expanded", String(!hidden))
  }
}
